export default interface LinkContentModel {
  relativePath?: string;
  absoluteUrl?: string;
}

export const getContentfulLink = (cm?: LinkContentModel) =>
  cm && (cm.relativePath || cm.absoluteUrl);
